import { render } from "./EntityManagement.vue?vue&type=template&id=3a9c9630&scoped=true"
import script from "./EntityManagement.vue?vue&type=script&lang=js"
export * from "./EntityManagement.vue?vue&type=script&lang=js"

import "./EntityManagement.vue?vue&type=style&index=0&id=3a9c9630&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a9c9630"]])

export default __exports__